import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'promotionList',
    initialState: {
        isRequesting: false,
        error: null,
        data: [],
        total: 0,
        searchPromotion: {},
        history: [],
        totalHistory: 0,
        searchHistory: {},
        allCompanies: []
    },
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchPromotion: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload.data.items,
                total: action.payload.data.total,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: [],
            };
        },
        delete_list: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
            };
        },
        update_list: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                // searchPromotion: { ...action.payload },
            };
        },
        get_history_list: (state) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                // searchHistory: { ...action.payload },
            };
        },
        get_history_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                history: action.payload.data.items,
                totalHistory: action.payload.data.total,
            };
        },
        get_all_companies: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
            };
        },
        get_all_companies_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                allCompanies: action.payload.data,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
